import { FC, useState } from "react";
import { toast } from "react-toastify";
import NotificationModalWindow from "./NotificationModalWindow";

interface INotificationMessageProps {
	toastId: string;
	isSuccess: boolean;
	message: string;
	dateTime: string | Date;
	additionData?: any;
	autoClose?: false | number;
};

/** Уведомление */
export const NotificationMessage: FC<INotificationMessageProps> = ( props ) => {

	const { toastId, isSuccess, message, dateTime, additionData, autoClose = 5000 } = props;

	const [ isShow, setIsShow ] = useState<boolean>(false);

	const toggleShow = () => {
		setIsShow( p => !p );
		// если закроется toast закроется и наша модалка, отключем автозакрытие на время открытие модалки
		toast.update(toastId, {
			autoClose: !isShow ? false : autoClose,
		});
	};


	return (
		<>
			<div
				style={{ width: "240px" , whiteSpace: 'pre-line' }}
				className='rdev__notify__listitem-text'
				dangerouslySetInnerHTML={{ __html: message }}
				onClick={toggleShow}>
			</div>

			<NotificationModalWindow
				close={toggleShow}
				isShow={isShow}
				isSuccess={isSuccess}
				message={message}
				additionData={additionData}
				date={dateTime}
			/>
		</>
	);
};
